import { useSelector } from 'react-redux';

export const useThemeColor = () => {
  const { primaryColor } = useSelector((state) => state.theme);
  
  return {
    primaryColor,
    // For backward compatibility with colorSchems.aispace
    aispaceColor: primaryColor,
    // Generate hover color (slightly darker)
    hoverColor: adjustBrightness(primaryColor, -20),
    // Generate focus color (slightly transparent)
    focusColor: adjustBrightness(primaryColor, 0, 0.2),
  };
};

// Helper function to adjust color brightness
const adjustBrightness = (hex, percent, alpha = 1) => {
  // Remove the # if present
  hex = hex.replace('#', '');
  
  // Parse the hex color
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  
  // Adjust brightness
  const adjustedR = Math.max(0, Math.min(255, r + percent));
  const adjustedG = Math.max(0, Math.min(255, g + percent));
  const adjustedB = Math.max(0, Math.min(255, b + percent));
  
  // Convert back to hex
  const adjustedHex = `#${Math.round(adjustedR).toString(16).padStart(2, '0')}${Math.round(adjustedG).toString(16).padStart(2, '0')}${Math.round(adjustedB).toString(16).padStart(2, '0')}`;
  
  // If alpha is specified, return rgba
  if (alpha < 1) {
    return `rgba(${adjustedR}, ${adjustedG}, ${adjustedB}, ${alpha})`;
  }
  
  return adjustedHex;
}; 